import Input from "../../../design/Input";


function AccountCheck({setDataToPayment, dataToPayment}) {

    return (
        <div className="account-aufa-continer">

            <div className="account-aufa-check">
                <div>
                    <p>בנק</p>
                    <Input textView={'bank'} pattern={'number'} value={dataToPayment.bank} onChange={(value) => setDataToPayment({...dataToPayment, bank: value})} />

                    <p>סניף</p>
                    <Input textView={'branch'} pattern={'number'} value={dataToPayment.branch} onChange={(value) => setDataToPayment({...dataToPayment, branch: value})} />

                    <p>תאריך</p>
                    <input 
                    type={'date'} 
                    value={dataToPayment.date} 
                    onChange={(event) => setDataToPayment({...dataToPayment, date: event.target.value})}
                    className="input"
                    />
                    {/* <Input type={'date'} value={dataToPayment.date} onChange={(event) => setDataToPayment({...dataToPayment, date: event.target.value})} /> */}
                </div>

                <div>
                    <p>מס' חשבון</p>
                    <Input textView={'account'} pattern={'number'} value={dataToPayment.account} onChange={(value) => setDataToPayment({...dataToPayment, account: value})} />

                    <p>מס' צ'ק</p>
                    <Input 
                    textView={'check number'} 
                    // pattern={'number'} 
                    value={dataToPayment.checkNumber} 
                    onChange={(value) => setDataToPayment({...dataToPayment, checkNumber: value})} 
                    />

                </div>
            </div>
        </div>
    )
}


export default AccountCheck;